export { ArrowDownCircle as default } from './ArrowDownCircle';
